import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TrashIcon from "@icons/myicons/trash-delete-bin-2.svg?react";
import { attachmentKind, formatFileSize } from "../helpers";

type Props = {
  file: File;
  onRemove: () => void;
};

export const AttachedFile = ({ file, onRemove }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={3}
      p={3}
      border={1}
      borderRadius={1}
      bgcolor={theme.palette.background.success}
      borderColor={theme.palette.text.positive}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        width={40}
        height={40}
        border={1}
        borderRadius={1}
        bgcolor={theme.palette.background.paper}
        borderColor={theme.palette.border.secondary}
      >
        <Typography
          variant="caption"
          fontWeight={500}
          color={theme.palette.primary.main}
        >
          {attachmentKind(file)}
        </Typography>
      </Box>

      <Box flex={1} minWidth={0}>
        <Typography variant="subtitle1" fontWeight={600} noWrap>
          {file.name}
        </Typography>
        <Typography variant="overline" color="textSecondary" fontWeight={500}>
          {formatFileSize(file.size)}
        </Typography>
      </Box>

      <IconButton
        size="small"
        aria-label={t("customerSupport.attachments.remove")}
        onClick={onRemove}
      >
        <TrashIcon
          width="16px"
          height="16px"
          color={theme.palette.icon.secondary}
        />
      </IconButton>
    </Box>
  );
};
